const l = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
    <path fill="currentColor" fill-rule="evenodd"
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.765 4.076C5.61087 3.97967 5.41659 3.97457 5.25762 4.06268C5.09864 4.15079 5 4.31824 5 4.5V9.5C5 9.68176 5.09864 9.84921 5.25762 9.93732C5.41659 10.0254 5.61087 10.0203 5.765 9.924L9.765 7.424C9.91119 7.33263 10 7.17239 10 7C10 6.82761 9.91119 6.66737 9.765 6.576L5.765 4.076Z"
        clip-rule="evenodd"></path>
</svg>`;
export {
  l as default
};
